import { Component, OnInit } from '@angular/core';
import { ActsService } from '../../core/services/acts.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-acts',
  templateUrl: './acts.component.html',
  styleUrls: ['./acts.component.scss'],
})
export class ActsComponent implements OnInit {
  breadcrumbs = [
    {
      title: 'Acts',
    },
  ];

  data: any[] = [];
  totalDocs = 0;
  currentPage = 1;
  pageSize = 24;
  years: number[] = [];
  selectedYear: number | null = null;

  constructor(
    private actsService: ActsService,
    private datePipe: DatePipe,
  ) {}

  ngOnInit(): void {
    this.loadYears();
    this.loadData();
  }

  loadYears(): void {
    this.actsService.getYears().then((years) => {
      this.years = years;
    });
  }

  loadData(): void {
    this.actsService
      .getActs(this.selectedYear || undefined, this.currentPage, this.pageSize)
      .then((response: any) => {
        this.data = response.docs || [];
        this.totalDocs = response.totalDocs || 0;
      });
  }

  filterByYear(): void {
    this.currentPage = 1;
    this.loadData();
  }

  clearFilter(): void {
    this.selectedYear = null;
    this.currentPage = 1;
    this.loadData();
  }

  onCurrentPageDataChange(page: number): void {
    this.currentPage = page;
    this.loadData();
  }

  getFileUrl(file: any): string {
    if (file && file.url) {
      return file.url;
    }
    if (file && typeof file === 'string') {
      return file;
    }
    return '#';
  }
}




